export default __webpack_public_path__ + "6d93eb68641425eaecb30570066921b8.svg";